import { OFFER_INCLUDES } from "@/lib/content";
import Reveal from "@/components/landing/Reveal";

export default function Offer() {
    return (
        <section
            id="offer"
            data-testid="offer-section"
            className="bg-pearl py-32 md:py-44 relative overflow-hidden"
        >
            <div className="grain opacity-[0.12]" aria-hidden="true" />
            <div className="max-w-[1100px] mx-auto px-6 md:px-12 relative">
                <div className="text-center max-w-[42rem] mx-auto">
                    <Reveal>
                        <p className="eyebrow text-clay mb-8">
                            <span className="divider-line text-clay/60 mr-4 align-middle" />
                            Your first step
                            <span className="divider-line text-clay/60 ml-4 align-middle" />
                        </p>
                    </Reveal>
                    <Reveal delay={120}>
                        <h2
                            data-testid="offer-headline"
                            className="font-serif text-cacao text-[2.4rem] sm:text-[3.2rem] md:text-[4.2rem] leading-[1.02]"
                        >
                            {"The Arc & Light"}
                            <span className="block italic text-clay-deep">
                                {"Discovery Consultation."}
                            </span>
                        </h2>
                    </Reveal>
                    <Reveal delay={240}>
                        <p className="mt-8 text-cacao/75 text-[1.05rem] md:text-[1.15rem] leading-[1.8] font-light">
                            {"From \u201Calmost right\u201D to \u201Cunmistakably home.\u201D A calm first conversation with Merilyn — and a clear direction for your space."}
                        </p>
                    </Reveal>
                </div>

                <div className="mt-20 md:mt-24 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                    {/* what's included */}
                    <Reveal className="lg:col-span-7">
                        <p className="eyebrow text-cacao/60 mb-6">{"What\u2019s included"}</p>
                        <ul
                            data-testid="offer-includes"
                            className="divide-y divide-cacao/10 border-y border-cacao/10"
                        >
                            {OFFER_INCLUDES.map((item, i) => (
                                <li
                                    key={item}
                                    className="py-5 flex items-start gap-5"
                                >
                                    <span className="font-serif text-clay text-[0.95rem] mt-1">
                                        0{i + 1}
                                    </span>
                                    <span className="text-cacao/85 text-[1rem] md:text-[1.05rem] leading-[1.65] font-light">
                                        {item}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </Reveal>

                    {/* promise / scarcity / CTA */}
                    <Reveal delay={200} className="lg:col-span-5">
                        <div className="bg-pearl-soft border border-cacao/10 p-8 md:p-10">
                            <p className="eyebrow text-clay mb-5">Our promise</p>
                            <p
                                data-testid="offer-promise"
                                className="font-serif italic text-cacao text-[1.2rem] md:text-[1.3rem] leading-[1.45]"
                            >
                                {"Leave your first consultation with a clear direction for your home \u2014 that\u2019s our promise."}
                            </p>

                            <div className="my-8 h-px bg-cacao/15" />

                            <p className="eyebrow text-cacao/60 mb-4">Limited spots</p>
                            <p className="text-cacao/75 text-[0.95rem] leading-[1.7] font-light">
                                Arc &amp; Light is a boutique studio. Merilyn takes a limited number of projects each season, so each home receives her full attention.
                            </p>

                            <a
                                href="#contact"
                                data-testid="offer-cta"
                                className="btn-clay mt-9 w-full"
                            >
                                Book Your Discovery Consultation
                            </a>
                            <p className="mt-5 text-cacao/55 text-[0.7rem] tracking-[0.22em] uppercase text-center">
                                60 seconds · No obligation · Reply within 1 business day
                            </p>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
